import { render } from "./index.vue?vue&type=template&id=1b3c7faa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabIcon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b3c7faa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b3c7faa', __exports__)) {
    api.reload('1b3c7faa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1b3c7faa", () => {
    api.rerender('1b3c7faa', render)
  })

}


export default __exports__